import { Link, useLocation } from "react-router-dom";
import { Globe, MapPin, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { counterpartPath, useAltPaths, useHref, useLang, useT } from "@/i18n";

export const Header = () => {
  const { pathname, search } = useLocation();
  const lang = useLang();
  const href = useHref();
  const t = useT();
  const { altPaths } = useAltPaths();

  const links = [
    { to: "/", label: t("nav.home"), testId: "nav-utama" },
    { to: "/directory", label: t("nav.directory"), testId: "nav-direktori" },
    { to: "/harga", label: t("nav.pricing"), testId: "nav-harga" },
  ];
  const other = lang === "ms" ? "en" : "ms";

  return (
    <header className="sticky top-0 z-50 glass-header border-b border-border/60">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8">
        <Link to={href("/")} data-testid="brand-logo" className="flex min-w-0 items-center gap-2">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-md bg-primary text-primary-foreground">
            <MapPin className="h-5 w-5" />
          </span>
          <span className="truncate font-display text-base font-bold tracking-tight sm:text-lg">
            Direktori<span className="text-primary">Biz</span>.my
          </span>
        </Link>

        <nav className="flex min-w-0 items-center gap-0.5 sm:gap-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={href(l.to)}
              data-testid={l.testId}
              className={`hidden rounded-md px-1.5 py-2 text-[13px] font-medium transition-colors duration-200 min-[480px]:block sm:px-3 sm:text-sm ${
                pathname === href(l.to) ? "text-primary" : "text-slate-600 hover:text-slate-900"
              }`}
            >
              {l.label}
            </Link>
          ))}

          <Link
            to={`${altPaths?.[other] || counterpartPath(pathname, other)}${search}`}
            data-testid="language-switch"
            aria-label={t("nav.language")}
            className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-border px-2 py-1.5 text-[12px] font-semibold uppercase tracking-wider text-slate-600 transition-colors duration-200 hover:border-primary hover:text-primary"
          >
            <Globe className="h-3.5 w-3.5" />
            {other === "en" ? "EN" : "BM"}
          </Link>

          <Link to={href("/submit")} data-testid="nav-submit">
            <Button size="sm" className="ml-1 shrink-0 bg-primary px-2.5 text-primary-foreground transition-colors duration-200 hover:bg-[#0052CC] sm:px-3">
              <Plus className="h-4 w-4 sm:mr-1.5" />
              <span className="hidden sm:inline">{t("nav.submit")}</span>
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
};
